import axios from 'axios';

/*
 * Cold-open prefetch, the consuming half. public/index.html starts the GETs a cold
 * open needs (the sign-in check, the shared farm status, and on `/` the Dashboard's
 * own calls) while the bundle is still loading and parsing, and leaves the promises
 * in window.__NK_BOOT__, keyed by the full URL axios builds ("/api/alerts").
 *
 * Without it every one of those calls waited for the bundle, then for /auth/me, then
 * for a render, and the light tiles and harvest card for one more round trip after
 * the Dashboard's first data: on the farm's ~250 ms link to us-east-1 that was most
 * of the time between the page painting and its data arriving.
 *
 * Rules that keep it from serving anything stale or wrong:
 *  - only successful (2xx) answers are served; anything else makes the real request;
 *  - only within BOOT_WINDOW_MS of the navigation; the minute polls go to the server;
 *  - the first write (any non-GET, sign-in included) drops the whole cache, so a
 *    refetch after a change always sees the change.
 * A URL listed in index.html that nothing asks for costs one wasted GET; a call
 * missing from the list simply goes to the server as before.
 */

const BOOT_WINDOW_MS = 20000;

let boot = (typeof window !== 'undefined' && window.__NK_BOOT__) || null;
const used = new Set();

const dropBoot = () => { boot = null; };

/* Request interceptor: answer a GET from the prefetch when it holds this URL. */
export function serveFromBoot(config, instance) {
  if (!boot) return config;
  if ((config.method || 'get').toLowerCase() !== 'get' || performance.now() > BOOT_WINDOW_MS) {
    dropBoot();
    return config;
  }
  const key = instance.getUri(config);
  const pending = boot[key];
  if (!pending) return config;
  used.add(key);
  const realAdapter = axios.getAdapter(config.adapter || axios.defaults.adapter);
  config.adapter = cfg => pending.then(
    data => ({ data, status: 200, statusText: 'OK', headers: {}, config: cfg, request: null }),
    () => realAdapter(cfg),
  );
  return config;
}

// In development, name the prefetched URLs nothing asked for: the list in
// index.html has drifted from the code.
if (boot && process.env.NODE_ENV !== 'production') {
  setTimeout(() => {
    const unused = Object.keys(window.__NK_BOOT__ || {}).filter(k => !used.has(k));
    if (unused.length) console.warn('index.html prefetched URLs nothing used:', unused);
  }, BOOT_WINDOW_MS);
}
